import AutoHomeCard from './AutoHomeCard';
import ExploreMoreBenefitsCard from './ExploreMoreBenefitsCard';
import PaperlessCard from './PaperlessCard';
import PolicyLinkCard from './PolicyLinkCard';
import StartClaimCard from './StartClaimCard';
import TransactionHistoryCard from './TransactionHistoryCard';
import UBIEnrollmentCard from './UBIEnrollmentCard';

interface InfoCardsProps {
  tabValue: number;
  ubiEnabled?: boolean;
  unenrolledPaperlessPolicy?: boolean;
  showAutoHomeCard?: boolean;
}

export const MarketingCards = [AutoHomeCard, ExploreMoreBenefitsCard];

export const getClaimsMarketingCards = (
  ubiEnabled?: boolean,
  unenrolledPaperlessPolicy?: boolean,
  addAutoHomeCard?: boolean
) => [
  StartClaimCard,
  ...(addAutoHomeCard ? [...MarketingCards] : [ExploreMoreBenefitsCard]),
  ...(unenrolledPaperlessPolicy ? [PaperlessCard] : []),
  ...(ubiEnabled ? [UBIEnrollmentCard] : []),
];

export const getBillsMarketingCards = (
  ubiEnabled?: boolean,
  unenrolledPaperlessPolicy?: boolean,
  addAutoHomeCard?: boolean
) => [
  TransactionHistoryCard,
  ...(addAutoHomeCard ? [...MarketingCards] : [ExploreMoreBenefitsCard]),
  ...(unenrolledPaperlessPolicy ? [PaperlessCard] : []),
  ...(ubiEnabled ? [UBIEnrollmentCard] : []),
];

export const getPolicyMarketingCards = (
  ubiEnabled?: boolean,
  unenrolledPaperlessPolicy?: boolean,
  addAutoHomeCard?: boolean
) => [
  PolicyLinkCard,
  ...(addAutoHomeCard ? [...MarketingCards] : [ExploreMoreBenefitsCard]),
  ...(unenrolledPaperlessPolicy ? [PaperlessCard] : []),
  ...(ubiEnabled ? [UBIEnrollmentCard] : []),
];

const InfoCards = ({
  tabValue,
  ubiEnabled,
  unenrolledPaperlessPolicy,
  showAutoHomeCard,
}: InfoCardsProps) => {
  const CARDS_MAP: { [key: string]: React.FC[] } = {
    0: getBillsMarketingCards(
      ubiEnabled,
      unenrolledPaperlessPolicy,
      showAutoHomeCard
    ),
    1: getPolicyMarketingCards(
      ubiEnabled,
      unenrolledPaperlessPolicy,
      showAutoHomeCard
    ),
    2: getClaimsMarketingCards(
      ubiEnabled,
      unenrolledPaperlessPolicy,
      showAutoHomeCard
    ),
  };

  return (
    <>
      {CARDS_MAP[tabValue].map((Component: React.FC, index: number) => (
        <Component key={index} />
      ))}
    </>
  );
};

export default InfoCards;
